export default __webpack_public_path__ + "static/media/hoppia_vtuber_01.9b125c79.png";